// useMemberships — TanStack Query hook for the current merchant's team.
//
// Mirrors usePayouts() / useApiKeys(): keyed per-merchant on currentMerchantId
// so the cache is scoped correctly when the user switches merchants. Guarded
// on authenticated status and a known merchant.
import { useQuery } from "@tanstack/react-query";

import { listMemberships } from "@/api/memberships";
import { useAuth } from "@/store/auth";
import { useUI } from "@/store/ui";

export function useMemberships() {
  const status = useAuth((s) => s.status);
  const currentMerchantId = useUI((s) => s.currentMerchantId);

  return useQuery({
    queryKey: ["memberships", currentMerchantId],
    queryFn: () => listMemberships(currentMerchantId!),
    enabled: status === "authenticated" && currentMerchantId != null,
    staleTime: 30_000,
  });
}
